module.exports = __webpack_public_path__ + "img/akouganngu_title7.5c55d826.jpg";